import Icons from '@/icons/index'

const KNOWN_SIDEBAR_ICONS = new Set(Icons.getNameList())

/**
 * 侧栏 icon 依 enName 映射（对应 src/icons/svg/*.svg 文件名，不含 .svg）。
 */
export const SIDEBAR_ICON_BY_EN_NAME = {
  dineTable: 'soc-display',
  configProfileLibrary: 'soc-files',
  coffeeMachineChannelSlots: 'soc-config',
  configBindDispatch: 'soc-m-configbinddispatch',
  simulatorGroup: 'soc-sim',
  x600hGateway: 'soc-m-x600hgateway',
  xt90c2Simulator: 'soc-sim',
  blenderSimulator: 'soc-sim',
  xosIviSimulator: 'soc-sim',
  hansonIviSimulator: 'soc-sim',
  deviceLinkDebug: 'soc-m-devicelinkdebug',
  x600hProductionOrder: 'soc-l1-prod-order',
  deviceProductionOrder: 'soc-l1-prod-order',
  globalDeviceAuthGroup: 'soc-l1-global-device-auth',
  globalDeviceCatalog: 'soc-global-catalog',
  globalDeviceCatalogApply: 'soc-global-catalog-apply',
  deviceOrderLifecycleGuide: 'soc-l1-domain-guide',
  globalDeviceRegistry: 'soc-global-registry',
  legacyDeviceMigrate: 'soc-global-migrate',
  deviceIssueSync: 'soc-global-issue-sync',
  brandServiceContract: 'soc-l1-brand-contract',
  brandServiceContractSummary: 'soc-brand-contract-summary',
  brandServiceContractDesk: 'soc-brand-contract-desk',
  brandServiceModeA: 'soc-l1-mode-a-data',
  brandServiceModeB: 'soc-l1-mode-b-addon',
  subscriptionBillingFolder: 'soc-l1-brand-contract',
  mySubscriptionPlan: 'soc-brand-contract-summary',
  deviceEndpointDataFolder: 'soc-l1-mode-a-data',
  mallPricingCollectFolder: 'soc-mall-price-book',
  socLeoAddonOverview: 'soc-addon-overview',
  socLeoAddonHomeList: 'soc-addon-home',
  socLeoAddonComList: 'soc-addon-com',
  socLeoAddonAiPack: 'soc-addon-ai-points',
  socMonDomainBasicOps: 'soc-l1-domain-basic',
  socMonDomainStoreOpsPlus: 'soc-l1-domain-store',
  socMonDomainHqMulti: 'soc-l1-domain-hq',
  socMonDomainPayIntegrate: 'soc-l1-domain-pay',
  socMonDomainAnalytics: 'soc-l1-domain-analytics',
  socMonDomainSmartGuidePlus: 'soc-l1-domain-guide',
  socSmartGuideBrandDesk: 'soc-guide-brand-desk',
  leoMonDomainBasic: 'soc-l1-leo-basic',
  leoMonDomainHomeAddon: 'soc-l1-leo-home',
  leoMonDomainComAddon: 'soc-l1-leo-com',
  leoMonDomainAiPoints: 'soc-l1-leo-ai-points',
  leoAiPointsBillingEntry: 'soc-leo-ai-points-bill',
  opsAnalyticsDesk: 'soc-ops-analytics-desk',
  xhmHardwarePartnerDesk: 'soc-l1-xhm-s0-month',
  xhmHardwarePartnerGroup: 'soc-l1-xhm-partner',
  leoKnowledgeGroup: 'soc-pillar-leo',
  leoKnowledgeModelFields: 'leo-model-fields',
  leoKnowledgeEquipmentTypeTypeKey: 'leo-type-key',
  leoKnowledgeUpload: 'leo-upload',
  leoKnowledgeIngestBatch: 'leo-batch',
  leoKnowledgePhase1Ssot: 'leo-ssot',
  leoKnowledgeCapabilityMatrix: 'leo-matrix',
  leoKnowledgeOnboarding: 'leo-onboard',
  leoKnowledgeTesterConsole: 'leo-tester',
  leoKnowledgePipelineHub: 'leo-pipeline',
  leoKnowledgeFeatureSurface: 'leo-api-map',
  leoKnowledgeProtocolDoc: 'leo-doc',
  leoKnowledgeRemoteTools: 'leo-remote',
  leoKnowledgeLearning: 'leo-learn',
  leoKnowledgeExternalIngest: 'leo-external',
  leoKnowledgePortalHub: 'leo-portal-hub',
  leoKnowledgeUiSurfaceSample: 'soc-m-leoknowledgeuisurfacesample',
  leoKnowledgeUiSurfaceSample2: 'theme',
  leoKnowledgeUiSurfaceSample3: 'theme',
  leoDeviceOpsRolePolicy: 'leo-policy',
  leoDeviceOpsSemanticTraining: 'leo-semantic',
  leoProductionE2eTraining: 'leo-t6',
  leoTrainingDashboard: 'leo-train',
  leoT2GoldenTraining: 'leo-golden',
  leoT9DeepseekTraining: 'leo-deepseek',
  leoTurnRoutingTrainingHub: 'leo-route',
  leoCommandOnboardingWizard: 'leo-wizard',
  leoKnowledgePortalOpsInventory: 'leo-inventory',
  leoKnowledgePortalOpsDailyHub: 'leo-portal-daily',
  leoDeviceOpsReviewInbox: 'leo-review',
  leoDeviceOpsDescriptionAutogen: 'leo-autogen',
  leoDeviceOpsBLineDailyHub: 'leo-b-line',
  leoDeviceOpsBundleCandidates: 'leo-bundle',
  leoXeeGrowthDashboard: 'leo-xee-growth',
  leoIntelligenceGrowthDashboard: 'leo-growth',
  leoTrainingDecisionDesk: 'leo-desk',
  leoTrainingWorkBoard: 'leo-train',
  leoTrainingFederationCommandCenter: 'leo-federation',
  leoTrainingFederationCases: 'leo-fed-cases',
  leoClawPlanCapabilityHub: 'leo-claw',
  leoTasteHabitPerception: 'leo-taste',
  leoKnowledgeFolderPortal: 'leo-folder-portal',
  leoKnowledgeFolderModel: 'leo-folder-model',
  leoKnowledgeFolderIngest: 'leo-folder-ingest',
  leoKnowledgeFolderProtocol: 'leo-folder-protocol',
  leoKnowledgeFolderOps: 'leo-folder-ops',
  // E1／设备智能：专用样稿 SVG（src/icons/svg/leo-e1-*.svg）
  leoKnowledgeFolderDeviceIntel: 'leo-e1-device',
  leoE1Overview: 'leo-e1-overview',
  leoE1Components: 'leo-e1-parts',
  leoE1Production: 'leo-e1-production',
  leoE1Proposals: 'leo-e1-inbox',
  leoE1Health: 'leo-e1-health',
  leoE1Impact: 'leo-e1-impact',
  leoE1Policy: 'leo-e1-policy',
  leoE1TargetQuality: 'leo-e1-target',
  leoE1Curves: 'leo-e1-curves',
  leoE1Peer: 'leo-e1-peer',
  leoE1LifeGate: 'leo-e1-life',
  memberHqGroup: 'soc-member',
  memberHqDashboard: 'soc-display',
  memberHqFinance: 'soc-business',
  memberHqOps: 'soc-maintenance',
  distributorReportGroup: 'soc-data',
  distributorDashboard: 'soc-display',
  distributorMembers: 'soc-member',
  distributorProfit: 'soc-business',
  homePage: 'soc-home',
  dataDisplay: 'soc-display',
  atlas: 'soc-atlas',
  journal: 'soc-journal',
  details: 'eye',
  // Phase A 五柱／一级（Icon Language SSOT）
  systemSetting: 'soc-pillar-system',
  deviceXhmPillar: 'soc-pillar-xhm',
  socOpsPillar: 'soc-pillar-ops',
  ecosystemMallGroup: 'soc-pillar-mall',
  loginAccount: 'soc-l1-accounts',
  authorization: 'soc-m-authorization',
  merchants: 'soc-l1-merchants',
  devices: 'soc-l1-device-list',
  deviceRdGroup: 'soc-l1-device-rd',
  afterSalesServiceGroup: 'soc-l1-after-sales',
  xhmFamilySlotGroup: 'soc-l1-xhm-slots',
  linuxAutoOps: 'soc-l1-linux-auto',
  storeOpsCeoDeskGroup: 'soc-l1-store-desk',
  storeAutopilotGroup: 'soc-l1-autopilot',
  socMemberFolder: 'soc-l1-members',
  storeMaterialGroup: 'soc-l1-store-stock',
  material: 'soc-l1-recipe-bom',
  deviceConfig: 'soc-config',
  channelConfiguration: 'soc-m-channelconfiguration',
  productCenter: 'soc-l1-products',
  productCenterFolderBasic: 'list',
  productCenterFolderProducts: 'soc-product',
  productCenterFolderMenu: 'nested',
  productCenterFolderChannels: 'bind',
  productCenterFolderAddons: 'soc-material',
  productCenterFolderOther: 'component',
  businessCenter: 'soc-l1-finance',
  dataCenter: 'soc-l1-data',
  maintenance: 'soc-maintenance',
  filesCenter: 'soc-l1-files',
  aiEngineeringControlGroup: 'soc-l1-release',
  leoBrandOnboardingGroup: 'soc-l1-brand-onboard',
  ecosystemMallTopology: 'soc-l1-mall-topology',
  ecosystemMallCatalog: 'soc-l1-mall-catalog',
  ecosystemMallLines: 'soc-l1-mall-lines',
  ecosystemMallProductSpecs: 'soc-l1-mall-specs',
  ecosystemMallSearch: 'soc-l1-mall-search',
  ecosystemMallIntents: 'soc-l1-mall-intent',
  ecosystemMallVendors: 'soc-l1-mall-vendor',
  ecosystemMallTrialSim: 'soc-l1-mall-sim',
  ecosystemMallBusinessPlans: 'soc-l1-mall-plan',
  ecosystemMallEquipmentDemands: 'soc-l1-mall-demand',
  ecosystemMallMediaBilling: 'soc-l1-mall-media',
  ecosystemMallWebsitePages: 'soc-l1-mall-web',
  ecosystemMallProductKnowledge: 'soc-l1-mall-knowledge',
  ecosystemMallSynergyEdges: 'soc-l1-mall-synergy',
  menuSetting: 'soc-m-menusetting',
  organization: 'soc-org',
  deviceList: 'soc-devices',
  channelCategory: 'soc-m-channelcategory',
  productCategory: 'soc-m-productcategory',
  optionCategory: 'soc-m-optioncategory',
  optionList: 'soc-m-optionlist',
  storeAccount: 'soc-m-storeaccount',
  stores: 'soc-m-stores',
  modelName: 'soc-devices',
  category: 'soc-material',
  configDistribute: 'soc-m-configdistribute',
  devicesChannels: 'soc-m-deviceschannels',
  productsList5: 'soc-m-productslist5',
  posCenter: 'soc-pos',
  produceFivePos: 'soc-pos',
  menuDistribute: 'soc-m-menudistribute',
  storeMenu: 'soc-m-storemenu-2',
  merchantsData: 'soc-data',
  merchantData: 'soc-data',
  devicsData: 'soc-data',
  productionData: 'soc-data',
  maintanenceData: 'soc-maintenance',
  devicesWorkingData: 'soc-data',
  afterSalesReminder: 'soc-m-aftersalesreminder',
  socNotificationCenter: 'soc-notification',
  maintenanceTips: 'soc-m-maintenancetips',
  fileUpgrade: 'soc-m-fileupgrade',
  dataDowloan: 'soc-m-datadowloan',
  materialList: 'soc-m-materiallist',
  accessoriesCategory: 'soc-m-accessoriescategory',
  accessoriesList: 'soc-m-accessorieslist',
  appsBanner: 'soc-m-appsbanner',
  advertisement: 'soc-m-advertisement',
  advertBind: 'soc-m-advertbind',
  advertDistribute: 'soc-m-advertdistribute',
  membersCenter: 'soc-member',
  orderCenter: 'soc-m-ordercenter',
  packBag: 'paper-cup',
  appsCenter: 'soc-apps',
  productsList2: 'soc-m-productslist2',
  XTSeriesData: 'soc-data',
  materialDate: 'soc-material',
  qualityData: 'soc-data',
  alertsLog: 'soc-m-alertslog',
  cleaningLog: 'soc-m-cleaninglog',
  coffeeData: 'soc-m-coffeedata',
  coffeeMachineProductionData: 'soc-data',
  coffeeMachineSingleCupData: 'maintain',
  coffeeSumData: 'soc-data',
  taxCenter: 'soc-tax',
  taxManagement: 'soc-tax',
  taxAllocation: 'soc-m-taxallocation-2',
  dataOfTeaExtractorMachine: 'soc-data',
  teaSingleCupParams: 'soc-data',
  dataOfBlendExtractorMachine: 'soc-data',
  dataOfMilkExtractorMachine: 'soc-data',
  beverageOutputData: 'soc-data',
  singleCupData: 'soc-data',
  faultLog: 'soc-m-faultlog-2',
  deliveryPlatform: 'soc-delivery',
  uber: 'soc-delivery',
  otherProducts: 'tab',
  listOfTeaExtractsProducts: 'soc-m-listofteaextractsproducts',
  deviceRdGroup: 'soc-rd',
  machineDebug: 'soc-rd',
  presetCommand: 'soc-cmd-preset',
  commandConfiguration: 'soc-cmd-config',
  operationAndMaintenanceServices: 'soc-m-operationandmaintenanceservices',
  productionList: 'soc-m-productionlist',
  smallMaterial: 'soc-material',
  takeoutProducts: 'soc-m-takeoutproducts',
  pointRule: 'soc-m-pointrule',
  couponManagement: 'soc-m-couponmanagement',
  couponList: 'soc-m-couponlist',
  additionalProducts: 'soc-m-additionalproducts',
  type: 'soc-m-type',
  produce: 'soc-m-produce',
  produceList4: 'soc-m-producelist4',
  smoothieMakerProduct: 'soc-m-smoothiemakerproduct',
  machineMenu: 'soc-m-machinemenu',
  systemLog: 'soc-m-systemlog',
  region: 'soc-org',
  menuNav: 'nested',
  merchantTokenBillingPlatform: 'soc-business',
  merchantDataBillingPlatform: 'soc-business',
  linuxAutoOps: 'soc-devices',
  linuxAutoEquipment: 'soc-devices',
  linuxAutoRemoteOps: 'soc-maintenance',
  linuxAutoProfileConfig: 'soc-files',
  linuxAutoDataBilling: 'soc-business',
  linuxAutoModelRegistry: 'list',
  linuxAutoPartnerDelivery: 'guide',
  linuxAutoFleetMonitor: 'soc-data',
  linuxAutoCanAutoMatch: 'soc-can-match',
  linuxAutoDbcEntitlement: 'soc-business',
  linuxAutoCabinFeatures: 'component',
  equipmentCategory: 'soc-devices',
  produceData: 'soc-data',
  teaMachineSimulator: 'soc-sim-tea',
  storefrontSimulator: 'soc-sim-storefront',
  financeAccountingReports: 'soc-acct-report',
  storeCostOptimizeDesk: 'soc-cost-optimize',
  storeOpsCeoDecisionDesk: 'soc-ceo-desk',
  workforceWeekSchedule: 'soc-wf-week',
  workforceClock: 'soc-wf-clock',
  workforceSummary: 'soc-wf-summary',
  workforceSmartRoster: 'soc-wf-smart',
  workforceMySchedule: 'soc-wf-mine',
  workforcePayroll: 'soc-wf-payroll',
  storeAutopilotExceptions: 'soc-autopilot-in',
  leoUmMemberAdmin: 'leo-um-member',
  supportTicketCreate: 'soc-ticket-create',
  supportTicketMine: 'soc-ticket-mine',
  supportTicketWorkbench: 'soc-ticket-desk',
  supportPlaybook: 'soc-ticket-playbook',
  deviceServiceWorkbench: 'soc-svc-desk',
  deviceServiceMyAssignments: 'soc-svc-task',
  deviceServiceAssignees: 'soc-svc-assignee',
  deviceServiceMaintenance: 'soc-svc-plan',
  deviceServiceFaultPolicy: 'soc-svc-fault',
  deviceServiceEnterprisePolicy: 'soc-svc-ent-policy',
  deviceServiceMobile: 'soc-svc-mobile',
  deviceServiceBills: 'soc-svc-bill',
  deviceServiceAnalytics: 'soc-svc-analytics',
  deviceAutoServiceGroup: 'soc-l1-device-service',
  storeMaterialStock: 'soc-mat-stock',
  storeMaterialOrders: 'soc-mat-order',
  storeMaterialConsumable: 'soc-mat-consumable',
  storeMaterialMq: 'soc-mat-mq',
  storeMaterialInvoice: 'soc-mat-invoice',
  storeMaterialBarcodeAlias: 'soc-mat-barcode',
  storeMaterialCount: 'soc-mat-count',
  storeMaterialBomWizard: 'soc-mat-bom',
  storeMaterialAnalytics: 'soc-mat-analytics',
  storeMaterialPhysicalMerge: 'soc-mat-merge',
  ecosystemMallMediaHub: 'soc-mall-media',
  ecosystemMallVirtualWorkspace: 'soc-mall-virtual',
  ecosystemMallSocOps: 'soc-mall-soc-ops',
  ecosystemMallPortraits: 'soc-mall-portraits',
  ecosystemMallImmersivePromo: 'soc-mall-immersive-promo',
  ecosystemMallAdOrchestrate: 'soc-mall-ad-orchestrate',
  ecosystemMallChannelCommand: 'soc-mall-channel-command',
  ecosystemMallBEndCrm: 'soc-mall-b-end-crm',
  ecosystemMallPromoContent: 'soc-mall-promo-content',
  ecosystemMallCompanyPay: 'soc-mall-company-pay',
  ecosystemMallPriceBook: 'soc-mall-price-book',
  ecosystemMallBillingPromo: 'soc-billing-promo',
  ecosystemMallAppDownloads: 'soc-mall-app-download',
  storeAutonomousMarketingDesk: 'soc-mkt-desk',
  storeAssortmentDesk: 'soc-assort-desk',
  aiEngineeringControlDesk: 'soc-eng-desk',
  storePnLDesk: 'soc-pnl-desk',
  hkTaxFilingDesk: 'soc-hk-tax',
  storeReceiptInbox: 'soc-store-receipt',
  xhmFamilySlotDesk: 'soc-xhm-slot-desk',
  hkMarketChannelDesk: 'soc-hk-pay',
  hkMarketSignup: 'soc-hk-signup',
  leoBrandOnboardingDesk: 'leo-onboard-desk',
  cnMarketChannelDesk: 'soc-cn-pay',
  cnMarketSignup: 'soc-cn-signup',
  storeAssortmentGroup: 'soc-l1-assortment',
  aiTrusteeAdmin: 'soc-ai-trustee',
  x600hGatewayData: 'soc-x600h-data',
  teaMachineMaterial: 'soc-tea-material',
  dispenserPrecision: 'soc-tea-material',
  dispenserMaterialLoss: 'soc-mat-consumable',
  dispenserMultiMachine: 'soc-data',
  dispenserEarlyBrew: 'soc-data',
  calibrationData: 'soc-calibration',
  fullPipeData: 'soc-fullpipe',
  ecosystemMallCommerceMatrix: 'soc-mall-price-book',
  financeAccountingGroup: 'soc-m-financeaccountinggroup',
  storeCostOptimizeGroup: 'soc-m-storecostoptimizegroup',
  workforceGroup: 'soc-m-workforcegroup',
  agentPermissionSteward: 'soc-m-agentpermissionsteward',
  supportTicketGroup: 'soc-m-supportticketgroup',
  equipmentModelRepair: 'soc-m-equipmentmodelrepair',
  equipmentLifecycle: 'soc-m-equipmentlifecycle',
  platformReleaseControl: 'soc-m-platformreleasecontrol',
  partnerApiAdmin: 'soc-m-partnerapiadmin',
  storeAutonomousMarketingGroup: 'soc-m-storeautonomousmarketinggroup',
  storePnLGroup: 'soc-m-storepnlgroup',
  hkMarketChannelGroup: 'soc-m-hkmarketchannelgroup',
  cnMarketChannelGroup: 'soc-m-cnmarketchannelgroup',
  leoT7TasteMl: 'soc-m-leot7tasteml',
  leoE2Formulas: 'soc-m-leoe2formulas',
  machineList: 'soc-m-machinelist'
}

/** 专用品牌图标：leo-e1-*／leo-*／soc-* 优先于 DB 旧通用名 */
export function isBrandedSidebarIcon (icon) {
  return /^(leo-e1-|leo-|soc-)/.test(icon || '')
}

function isLegacyElementIcon (icon) {
  return /^el-icon-/i.test(icon) || /^el-icon$/i.test(icon)
}

function isValidSidebarIcon (icon) {
  return icon && KNOWN_SIDEBAR_ICONS.has(icon) && !isLegacyElementIcon(icon)
}

/**
 * 解析单条侧栏菜单应展示的 SVG 图标名。
 */
export function resolveSidebarMenuIcon (menu) {
  if (!menu) return 'list'
  const hasChildren = Array.isArray(menu.menuList) && menu.menuList.length > 0
  const en = menu.enName != null ? String(menu.enName).trim() : ''
  const raw = menu.icon != null ? String(menu.icon).trim() : ''
  const mapped = en ? SIDEBAR_ICON_BY_EN_NAME[en] : ''
  // 已登记的专用样稿优先（避免 DB 仍写 list/chart 时压住新图标）
  if (isBrandedSidebarIcon(mapped) && isValidSidebarIcon(mapped)) return mapped
  if (isValidSidebarIcon(raw)) return raw
  if (isValidSidebarIcon(mapped)) return mapped
  return hasChildren ? 'nested' : 'list'
}

/** 递归补齐侧栏树 icon（空值、Element 旧图标、未注册 SVG 名均会修正）。 */
export function fillSidebarMenuIcons (nodes) {
  if (!Array.isArray(nodes)) return
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    if (Array.isArray(n.menuList) && n.menuList.length) {
      fillSidebarMenuIcons(n.menuList)
    }
    n.icon = resolveSidebarMenuIcon(n)
  }
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/utils/sidebarMenuIcons.js